import { CommentatorsStack } from '@components/ArtBoard/Threads'
import { CheckCircleSolid } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import type { Recipient } from '@/types'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  active: boolean
  resolved: boolean
  avatars: (Recipient | null)[]
  className?: string
}

// todo: use it in ThreadBubble
export const ThreadAvatars: React.FC<Props> = ({
  active,
  avatars,
  className,
  resolved,
}) => {
  const iconClass = clsJoin(
    css.resolved_icon,
    css.right_top,
    !resolved && css.open
  )

  const containerClasses = clsJoin(
    css.thread_avatars,
    active && css.active,
    resolved && css.resolved,
    className
  )

  return (
    <div className={containerClasses}>
      <CommentatorsStack
        className={css.bubble}
        active={false}
        avatars={avatars}
        resolved={resolved}
      />
      <CheckCircleSolid className={iconClass} />
    </div>
  )
}
